import { render, staticRenderFns } from "./blockNum.vue?vue&type=template&id=1e8fe57e&scoped=true&"
import script from "./blockNum.vue?vue&type=script&lang=js&"
export * from "./blockNum.vue?vue&type=script&lang=js&"
import style0 from "./blockNum.vue?vue&type=style&index=0&id=1e8fe57e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8fe57e",
  null
  
)

export default component.exports